import { Component, ViewChild, OnInit, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { CallstatusService } from './callstatus.service';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Callstatus } from './callstatus.model';
import { Subscription } from 'rxjs';
import { MatSort } from '@angular/material/sort';
import { AuthenticationService } from '../../../service/authentication.service';
import { ApiService } from '../../../service/api.service';
import { UtilsService } from '../../../service/helper/utils.service';
import { MAT_MOMENT_DATE_FORMATS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatInput } from '@angular/material/input';
import Speech from 'speak-tts';

@Component({
  selector: 'app-callstatus',
  templateUrl: './callstatus.component.html',
  styleUrls: ['style.scss'],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'it-IT' },
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
  ]
})
export class CallstatusComponent implements OnInit, OnDestroy {
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild('start', { read: MatInput, static: false }) start: MatInput;
  @ViewChild('end', { read: MatInput, static: false }) end: MatInput;
  private subscription: Subscription;

  dataSource: MatTableDataSource<Callstatus>;
  pageSize = 50;
  itemCount = 1000;
  public id: number;
  profile: string;
  index = [];

  filterSelectObj = [
  { name: 'Data/Ora', columnProp: 'timestamp', options: [], modelValue: undefined },
  { name: 'ID impianto', columnProp: 'plantid', options: [], modelValue: undefined },
  { name: 'Messaggio', columnProp: 'message', options: [], modelValue: undefined },
  { name: 'Reperibile', columnProp: 'available', options: [], modelValue: undefined },
  { name: 'Stato', columnProp: 'status', options: [], modelValue: undefined },
  { name: 'Numero', columnProp: 'number', options: [], modelValue: undefined },
  { name: 'Tessera', columnProp: 'card', options: [], modelValue: undefined },
];

  filterValues = {};
  filter = { message: "", plantid: "", available: "", start: 0, end: 0, status: "", number: "", card: "" };
  displayedColumns: string[] = ['timestamp', 'plantid', 'message', 'available', 'status', 'number', 'card', 'actions', 'reset'];
  speech;

  constructor(
    private authenticationService: AuthenticationService,
    private callstatusService: CallstatusService,
    private changeDetectorRefs: ChangeDetectorRef,
    private storageService: ApiService,
    private utilsService: UtilsService
  ) {

  }

  ngAfterContentChecked() {
    this.changeDetectorRefs.detectChanges();
  }

  calculatestatus(status) {
    if (["S", "INSERTED", "PENDING", "SENT"].includes(status)) return 'yellow';
    if (["R", "DELIVERED"].includes(status)) return 'green';
    if (["K", "NOSENT", "NOTDELIVERED"].includes(status)) return 'red';
    return '';
  }

  calculatestatuscolor(status) {
    if (["S", "INSERTED", "PENDING", "SENT"].includes(status)) return 'black';
    if (["R", "DELIVERED", "K", "NOSENT", "NOTDELIVERED"].includes(status)) return 'white';
    return '';
  }

  reSend(element) {
    this.storageService.resend({ number: element.number, plantid: element.plantidshort, code: element.message }).subscribe();
  }

  simplestatus(status) {
    const statusMap = {
      "S": "Spedito", "INSERTED": "Spedito", "PENDING": "Spedito", "SENT": "Spedito",
      "R": "Ricevuto", "DELIVERED": "Ricevuto",
      "K": "Non spedito/Non ricevuto", "NOSENT": "Non spedito/Non ricevuto", "NOTDELIVERED": "Non spedito/Non ricevuto"
    };
    return statusMap[status] || '';
  }

  updateEnd(end) {
    this.filter["end"] = (new Date(end._selected._d)).getTime()
    this.getData(0, this.pageSize, this.filter)
  }
  updateStart(start) {
    this.filter["start"] = (new Date(start._selected._d)).getTime()
    this.getData(0, this.pageSize, this.filter)
  }

  getServerData(event?: PageEvent) {
    this.getData(event.pageIndex, event.pageSize, this.filter);
  }

  filterChange(filter, event) {
    this.filter[filter.columnProp] = filter.modelValue;
    this.getData(0, this.pageSize, this.filter);
  }

  resetFilters() {
    this.filter = { message: "", plantid: "", available: "", start: 0, end: 0, status: "", number: "", card: "" };
    this.filterValues = {};
    this.filterSelectObj.forEach(value => (value.modelValue = undefined));
    this.dataSource.filter = '';
    this.start.value = '';
    this.end.value = '';
    this.getData(0, this.pageSize, []);
  }

  createFilter() {
    return (data: any, filter: string): boolean => {
      const searchTerms = JSON.parse(filter);
      return Object.keys(searchTerms).every(col => searchTerms[col].toString() === '' || data[col] === searchTerms[col]);
    };
  }

  getData(pageIndex, pageSize, filter) {
    this.utilsService.showLoader();
    this.profile = this.authenticationService.currentUserValue.profile;
    this.storageService.getCallstatus(pageIndex, pageSize, filter);
    this.itemCount = parseInt(this.callstatusService.getCallstatuscount());
    this.dataSource = new MatTableDataSource(this.callstatusService.getCallstatus());
    this.subscription = this.callstatusService.callstatusChanged.subscribe((callstatuss: Callstatus[]) => {
      this.dataSource = new MatTableDataSource(callstatuss);
      this.dataSource.sort = this.sort;
      this.changeDetectorRefs.detectChanges();
      this.utilsService.hideLoader();
      this.dataSource.filterPredicate = this.createFilter();
      this.changeDetectorRefs.detectChanges();
    });

    this.subscription = this.callstatusService.callstatuscountChanged.subscribe(
      (callstatuscount: string) => { this.itemCount = parseInt(callstatuscount); }
    );
  }

  ngOnInit() {
    this.storageService.getCallColumn().subscribe(v => {
              console.log(v)

      this.filterSelectObj.forEach(o => {
        console.log(v[o.columnProp])
        if (o.columnProp === 'status') o.options = ["Ricevuto", "Spedito", "Non spedito/Non ricevuto"];
        else if (o.columnProp !== 'status' && o.columnProp !== 'email') o.options = v[o.columnProp].sort();
      });
    });

    this.speech = new Speech();
    this.speech.init({
      volume: 1, lang: "it-IT", rate: 0.7, pitch: 1,
    }).catch(e => {});

    this.getData(0, this.pageSize, []);
  }

  tts(message) {
    this.storageService.getAlarmcodesList().subscribe((data) => {
      const alarmMessage = data.some(a => a.includes(message.message))
        ? `Presso l'impianto di ${message.plantid} al giorno ${message.timestamp} si è verificato l'allarme ${message.message}`
        : `Presso l'impianto di ${message.plantid} al giorno ${message.timestamp} si è verificato l'allarme con testo libero ${message.message}`;
      this.speech.speak({ text: alarmMessage });
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  downloadFile(data, filename = 'data') {
    const csvData = this.ConvertToCSV(data, this.displayedColumns);
    const blob = new Blob(['\ufeff' + csvData], { type: 'text/csv;charset=utf-8;' });
    const dwldLink = document.createElement("a");
    const url = URL.createObjectURL(blob);
    if (navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1) {
      dwldLink.setAttribute("target", "_blank");
    }
    dwldLink.setAttribute("href", url);
    dwldLink.setAttribute("download", filename + ".csv");
    dwldLink.style.visibility = "hidden";
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
  }

  ConvertToCSV(objArray, headerList) {
    const array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray;
    array.forEach(v => { delete v.id; delete v.timestamp; });
    let str = `${Object.keys(array[0]).map(value => `"${value}"`).join(",")}\r\n`;
    return array.reduce((str, next) => {
      str += `${Object.values(next).map(value => `"${value}"`).join(",")}\r\n`;
      return str.replace(/['"]+/g, '');
    }, str.replace(/['"]+/g, ''));
  }

  download() {
    this.downloadFile(this.callstatusService.getCallstatus(), 'stato_chiamate');
  }
}
